import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddSwitchPointComponent } from 'src/app/core/dialogs/add-switch-point/add-switch-point.component';
import { DeleteSwitchPointComponent } from 'src/app/core/dialogs/delete-switch-point/delete-switch-point.component';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { RefreshGridComponent } from 'src/app/core/refresh-grid/refresh-grid.component';
import { FiscalYearService } from 'src/app/service/fiscal-year.service';
import { SwitchPointService } from 'src/app/service/switch-point.service';

export interface AddDialogData {
	performAction: string;
	page;

	placeholder_fiscalYear: string;
	placeholder_switchPointID;
	placeholder_switchPointCode;
	placeholder_costPerM3;
	// placeholder_user;
}

export interface DeleteSwitchPointData {
	id: Number;
	switchPoint: string;
	page;
}

@Component({
	selector: 'app-switch-points',
	templateUrl: './switch-points.component.html',
	styleUrls: ['./switch-points.component.scss'],
	standalone: false // NOSONAR
})
export class SwitchPointsComponent implements OnInit {

	frameworkComponents;
	icons;
	defaultColDef;

	fiscalYears: any = [];
	fiscalYearChosen = '';
	gridApi: any;
	gridColumnApi: any
	setPagination = 'true';
	rowCount;
	rowData: any[];
	tempData: any[];
	enableGrid: boolean = false;
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	selectedRows: any = [];
	paginationPageSize: number = 30;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 30 , selected : true},
		{value: 50 , selected : false},
	]
	originalPage: any;

	usertemp: string;
	userInfo: any;
	strUserName;

	successMessage = '';
	errorMessage = '';

	@ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	context: any;
	columnDefs;

	constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, public dialog: MatDialog,
		private readonly  fiscalYearService: FiscalYearService, private readonly switchPointService: SwitchPointService) {
		this.dynamicHeight = 0.665 * (window.innerHeight);

		this.context = {
			componentParent: this
		};
		this.columnDefs = [
			{
				headerName: '', width: 40, maxWidth: 40, minWidth: 40, autoHeight: true, floatingFilterComponent: RefreshGridComponent,
				suppressHeaderMenuButton: true, filter: 'agTextColumnFilter', sortable: false, suppressHeaderFilterButton: true,
				floatingFilterComponentParams: { suppressFilterButton: true }
			},
			{
				headerName: "SWITCH POINT", headerClass: "switchPoint", field: "switchPointCode", width: 325,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "COST PER M3", headerClass: "costPerM3", field: "costPerM3", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter',
				floatingFilterComponentParams: { suppressFilterButton: true }
			},
			{
				headerName: "CREATED BY", headerClass: "createdBy", field: "createdBy", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "CREATED ON", headerClass: "created", field: "createdDate", width: 180,
				sortable: true, unSortIcon: true, autoHeight: true, filter: 'agTextColumnFilter'
			},
			{
				headerName: "ACTIONS", headerClass: "editdelete", field: "switchpoints_action", width: 120,
				autoHeight: true, cellRenderer: BtnCellRenderer,
				cellRendererParams: {
					clicked: function (_field: any, _act: any) {
						console.info('some')
					}
				}
			}
		];

		this.frameworkComponents = {
			btnCellRenderer: BtnCellRenderer
		};

		this.defaultColDef = {
			minWidth: 100,
			floatingFilter: true,
			wrapText: true
		};

		this.icons = {
			sortUnSort: '<img src="./assets/images/unsort.svg">',
		  };
	}

	ngOnInit(): void { // NOSONAR 

		this.loadFYData();
	}

	loadFYData() {
		this.ngxUiLoaderService.start("loader-01");
		//get fiscal year list - api
		this.fiscalYears = [];

		this.fiscalYearService.getFiscalYearList().subscribe(result => {
			console.info("calling getFiscalYearList");
			if (result?.length > 0) {
				//storing templates data in local
				localStorage.setItem('fiscal-year-data', JSON.stringify(result));
				this.fiscalYears = result;
			}
			else {
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
			this.ngxUiLoaderService.stop("loader-01");
		});
	}

	display() {
		if (this.fiscalYearChosen) {
			this.enableGrid = true;
			this.rowData = [];
			this.tempData = [];

			this.ngxUiLoaderService.start("loader-01");

			console.info("the selected fiscal year", this.fiscalYearChosen);
			this.switchPointService.getDetails(this.fiscalYearChosen).subscribe(aprCostData => {
				aprCostData?.forEach(e => {
					const obj = {
						"switchPointID": undefined, "fiscalYear": undefined, "switchPointCode": undefined, "costPerM3": undefined,
						"createdDate": undefined, "createdBy": undefined
					};

					obj.switchPointID = e.switchPointID;
					obj.fiscalYear = e.fiscalYear;
					obj.switchPointCode = e.switchPointCode;
					obj.costPerM3 = e.costPerM3;
					obj.createdBy = e.createdBy;
					obj.createdDate = e.createdDate;

					this.tempData.push(obj);
					console.info("Switch Point data set to the object")
				});
				this.rowData = this.tempData;
				this.rowCount = this.rowData.length;
				this.ngxUiLoaderService.stop("loader-01");
			});
		}
		else {
			this.enableGrid = false;
		}
	}

	sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

	onPageSizeChanged(event: any) { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails(); }

	getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event: any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}

	refreshData() {
		this.display();
	}

	setUserData() {
		//fetch from local-storage
		// this.usertemp = localStorage.getItem('user-info');
		// this.userInfo = JSON.parse(this.usertemp);
		// this.strUserName = this.userInfo[0].strUserName; // Commented to get the same info from APM

		this.usertemp = sessionStorage.getItem('FGA');
		this.userInfo = JSON.parse(this.usertemp);
		this.strUserName = this.userInfo?.user?.userPrincipalName;
	}

	addSwitchPoint(): void {
		console.info("add switch point dialog opened");
		this.setUserData();	// To set created by user

		const dialogRef = this.dialog.open(AddSwitchPointComponent, {
			disableClose: true,
			width: '410px',
			data: { performAction: 'AddCell', placeholder: '', placeholder_fiscalYear: this.fiscalYearChosen }
		});

		dialogRef.afterClosed().subscribe(result => {
			console.info('add switch point dialog was closed', result);

			if (result != undefined && result.event == 'AddCell') {  // NOSONAR
				//API Integration
				const dataArr = {
					"fiscalYear": result.data1,
					"switchPointCode": result.data2,
					"costPerM3": result.data3,
					"createdBy": this.strUserName
				}

				console.info("data arr", dataArr);

				this.ngxUiLoaderService.start("loader-01");
				this.switchPointService.addSwitchPoint(dataArr).subscribe(result => {
					console.info("result", result);

					if (!result) {
						this.display();

						this.errorMessage = 'Switch Point already exists!';
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 5000);
					}
					else if (result) {
						this.display();
						this.successMessage = 'Switch Point added successfully!';

						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 5000);
					}
				});
			}
		});
	}

	deleteSwitchPointRow(val) {
		let switchPointCode;
		let id;

		this.rowData.filter(x => x.switchPointID == val).forEach(e => {  // NOSONAR
			this.selectedRows.push(e);
			id = e.switchPointID;
			switchPointCode = e.switchPointCode;
		});

		const dialogRef = this.dialog.open(DeleteSwitchPointComponent, {
			disableClose: true,
			width: '510px',
			data: { id: id, switchPoint: switchPointCode, page: 'switch point' }
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result != undefined) { // NOSONAR
				console.info('The dialog was closed', result);
				console.info("data to be deleted:", result.data);

				const deletejson = {
					"switchPointID": result.data
				}

				this.deleteSwitchPoint(deletejson);
				console.info("json", deletejson);
			}
		});
	}

	deleteSwitchPoint(dataArr) {
		console.info("the delete array in deleteSwitchPoint", dataArr);
		this.ngxUiLoaderService.start("loader-01");

		this.switchPointService.deleteSwitchPoint(dataArr).subscribe(_result => {
			this.successMessage = 'Deleted Row(s) Successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);

			//fetch latest row data after deleting
			this.display();
		});
	}

	editSwitchPointRow(val) {
		let id;
		let switchPointCode;
		let costPerM3;

		this.rowData.filter(x => x.switchPointID == val).forEach(e => {  // NOSONAR
			id = e.switchPointID;
			switchPointCode = e.switchPointCode;
			costPerM3 = e.costPerM3;
		});

		console.info("switchPointID", id); console.info("Switch Point Code", switchPointCode);
		console.info("costPerM3", costPerM3);

		const dialogRef = this.dialog.open(AddSwitchPointComponent, {
			disableClose: true,
			width: '410px',
			data: {
				performAction: 'EditCell', placeholder_switchPointID: id, placeholder_switchPointCode: switchPointCode,
				placeholder_costPerM3: costPerM3, page: 'switch point'
			}
		});

		this.setUserData();	// To set updated by user

		dialogRef.afterClosed().subscribe(result => {
			console.info('The dialog was closed', result);

			if (result != undefined && result.event == 'EditCell') { // NOSONAR
				//API Integration
				const dataArr = {
					"switchPointID": result.data0,
					"costPerM3": result.data1,
					"updatedBy": this.strUserName
				}

				this.ngxUiLoaderService.start("loader-01");
				this.switchPointService.editSwitchPoint(dataArr).subscribe(result => {
					
					if(result){
						this.successMessage = 'Switch Point updated successfully!';
					}else {
						this.errorMessage = "Something went wrong. Please Contact system administrator"
					}
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);

					//fetch latest row data after editing
					this.display();
					// }
				});
			}
		});
	}
}
